module.exports = __webpack_public_path__ + "d7e8ce75af999845e5af3cfecdfe9e74.png";